var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { class: ["content bg-light", { expanded: !_vm.isSidebarOpen }] },
          [
            _c(
              "b-container",
              { attrs: { fluid: "" } },
              [
                _c(
                  "div",
                  { staticClass: "content-title" },
                  [
                    _c("b-row", [
                      _c("h1", [_vm._v("Digital Credit Transfer")]),
                    ]),
                    _vm._v(" "),
                    _c("b-row", [
                      _c("span", { staticClass: "subtitle" }, [
                        _vm._v("Sandbox Dashboard"),
                      ]),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("b-row", [_c("h3", [_vm._v("Backend Management")])]),
                _vm._v(" "),
                _c("b-row", [
                  _c("span", { staticClass: "subtitle" }, [
                    _vm._v(
                      "Administrative tools for VIBAN management and reconciliation"
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "menu-grid" },
                  _vm._l(_vm.menu, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "menu-card",
                        style: {
                          backgroundColor: item.background,
                          borderColor: item.border,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.goto(item.url)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "menu-icon" }, [
                          _c("i", { class: ["fa-regular", item.symbol] }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "menu-content" }, [
                          _c("span", { staticClass: "menu-title" }, [
                            _vm._v(_vm._s(item.title)),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "menu-description" }, [
                            _vm._v(_vm._s(item.content)),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("b-row", [_c("h3", [_vm._v("System Overview")])]),
                _vm._v(" "),
                _c("b-row", [
                  _c("span", { staticClass: "subtitle" }, [
                    _vm._v("Key metrics and system status"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stats" }, [
                  _c("div", { staticClass: "stat-card stat-danger" }, [
                    _c("span", { staticClass: "stat-header" }, [
                      _c("i", {
                        staticClass: "fa-light fa-triangle-exclamation",
                      }),
                      _vm._v("\n              Overdue Items\n            "),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "stat-value" }, [
                      _vm._v(
                        "€" + _vm._s(Number(_vm.overdueAmount).toFixed(2))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "stat-sub" }, [
                      _vm._v(_vm._s(_vm.overdueOrders) + " orders"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stat-card stat-info" }, [
                    _c("span", { staticClass: "stat-header" }, [
                      _c("i", { staticClass: "fa-light fa-calendar-check" }),
                      _vm._v("\n              Not Yet Due\n            "),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "stat-value" }, [
                      _vm._v(
                        "€" + _vm._s(Number(_vm.notYetDueAmount).toFixed(2))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "stat-sub" }, [
                      _vm._v(_vm._s(_vm.notYetDueOrders) + " orders"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stat-card stat-success" }, [
                    _c("span", { staticClass: "stat-header" }, [
                      _c("i", { staticClass: "fa-light fa-chart-line-up" }),
                      _vm._v("\n              Today's Volume\n            "),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "stat-value" }, [
                      _vm._v(
                        "€" + _vm._s(Number(_vm.reconciledAmount).toFixed(2))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "stat-sub" }, [
                      _vm._v("Total Reconciled"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stat-card stat-purple" }, [
                    _c("span", { staticClass: "stat-header" }, [
                      _c("i", { staticClass: "fa-light fa-square-check" }),
                      _vm._v(
                        "\n              Today's Reconciliation\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "stat-value" }, [
                      _vm._v(_vm._s(_vm.reconciliationCount)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "stat-sub" }, [
                      _vm._v("Transactions Matched"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "stat-card stat-warning" },
                    [
                      _c("span", { staticClass: "stat-header" }, [
                        _c("i", { staticClass: "fa-light fa-bolt-lightning" }),
                        _vm._v(
                          "\n              Automation Rate\n              "
                        ),
                        _c("a", { attrs: { id: "info", href: "#" } }, [
                          _c("i", {
                            staticClass: "fa-light fa-circle-question",
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-popover",
                        {
                          attrs: {
                            target: "info",
                            triggers: "hover",
                            placement: "top",
                            "custom-class": "popover-info",
                          },
                        },
                        [
                          _c("div", [_vm._v("Automation Rate")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "\n                Percentage of reconciliations completed automatically without\n                manual intervention. Target: >95%.\n              "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "stat-value" }, [
                        _vm._v(_vm._s(_vm.automationRate) + "%"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "stat-sub" }, [
                        _vm._v("Auto vs Manual"),
                      ]),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }